// extracted by mini-css-extract-plugin
export default {"fr-view":"LanguageSelector_fr-view__TEnhJ","toggle":"LanguageSelector_toggle__j3bLP"};